import {UyapRequest} from "./UyapRequest";

export interface TevziSiraTipleriTalep {
    birimId: string
}

export type TevziSiraTipleriCevap = Array<TevziSiraTipleriCevapItem>

export interface TevziSiraTipleriCevapItem {
    yasakliIcraDaireleriSiraNo: string,
    talimatIcinSiraOlustur: boolean,
    kayitID: number,
    adliyeBirimID: string,
    tevziTip: number,
    icraDaireTip: number,
    tevziSiraTakipTip: string,
    tevziSiraTakipTipAdi: string,
    ensonTvzIcrDairSrNo: number
}

export default class TevziSiraTipleri extends UyapRequest<TevziSiraTipleriTalep, TevziSiraTipleriCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "tevziSiraTipleri_" + this.talepData.birimId
        };
    }

    getSpinnerMessage(){
        return "Tevzi sıra tipleri alınıyor...";
    }

    getMockResponse(): any {
        return [{"yasakliIcraDaireleriSiraNo":"","talimatIcinSiraOlustur":false,"kayitID":486149,"adliyeBirimID":"1004788","tevziTip":0,"icraDaireTip":3,"tevziSiraTakipTip":"TVTKP0010","tevziSiraTakipTipAdi":"Hapis Hakkı","ensonTvzIcrDairSrNo":1},{"yasakliIcraDaireleriSiraNo":"","talimatIcinSiraOlustur":false,"kayitID":506629,"adliyeBirimID":"1004788","tevziTip":0,"icraDaireTip":3,"tevziSiraTakipTip":"TVTKP0002","tevziSiraTakipTipAdi":"Çocuk Teslimi","ensonTvzIcrDairSrNo":1},{"yasakliIcraDaireleriSiraNo":"","talimatIcinSiraOlustur":false,"kayitID":22529,"adliyeBirimID":"1004788","tevziTip":0,"icraDaireTip":3,"tevziSiraTakipTip":"TVTKP0006","tevziSiraTakipTipAdi":"Tedbir Kararları","ensonTvzIcrDairSrNo":3},{"yasakliIcraDaireleriSiraNo":"","talimatIcinSiraOlustur":false,"kayitID":12802,"adliyeBirimID":"1004788","tevziTip":0,"icraDaireTip":3,"tevziSiraTakipTip":"TVTKP0001","tevziSiraTakipTipAdi":"Nafaka Takibi","ensonTvzIcrDairSrNo":23}];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'tevziSiraTipleri.ajx';
    }

    async parse(data: any): Promise<TevziSiraTipleriCevap> {
       return data;
    }
}